(function () {
    'use strict';

    var flatpickr = require('flatpickr');
    var $countrySearch = $('#country-search');
    var $weather = $('.weather');

    $weather.on('dblclick', function (e) {
        if ($weather.length === 0 || $countrySearch.val().length > 0) {
            return;
        }

        setCountryAndLocation();
        setPickupAndDropoffDates();
        setAge();
    });

    function setCountryAndLocation() {
        var $locationSearch = $('#location-search');
        var countrySearch = $countrySearch[0].selectize;
        var locationSearch = $locationSearch[0].selectize;

        $(document).on('dataLoaded', function (e) {
            locationSearch.setValue(11); // Leicester
        });

        countrySearch.setValue(1); // United Kingdom
    }

    function setPickupAndDropoffDates() {
        flatpickr('#pickup-date-group').setDate(moment().add(7, 'days').toDate());
        flatpickr('#dropoff-date-group').setDate(moment().add(8, 'days').toDate());
    }

    function setAge() {
        var $age = $('#age');
        var age = $age[0].selectize;

        age.setValue(35);
    }
})();
